import React from "react";
import { Link } from "react-router-dom";
import wordmark from "../Icons_Logos/jobspace-wordmark-outlined-sq_handle.svg";
import icon from "../Icons_Logos/jobspace-icon-sq_handle.svg";

/*
  JobSpaceLogo — single source of truth for the JobSpace brand mark.
  variant: "wordmark" (default, full lockup) | "icon" (compact magnifier mark).
  height: pixel height; width scales automatically.
  to: when provided, wraps the logo in a react-router Link.
*/
export default function JobSpaceLogo({ variant = "wordmark", height = 30, to, style, ...rest }) {
  const src = variant === "icon" ? icon : wordmark;
  const img = (
    <img
      src={src}
      alt="JobSpace"
      height={height}
      style={{ height, width: "auto", display: "block", ...style }}
      {...rest}
    />
  );
  return to ? (
    <Link to={to} style={{ display: "inline-flex", textDecoration: "none" }}>{img}</Link>
  ) : (
    img
  );
}
